document.addEventListener('DOMContentLoaded', () => {
	/* Accordion mini */
	/* -------------------------------------------------------------------------------------- */
	$('.js-accordion-group').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.closest('.js-accordion-item').toggleClass('show-body');
		el.closest('.js-accordion-item').siblings('.js-accordion-item').removeClass('show-body');
	});

	$('body').on('click', '.js-accordion', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.closest('.js-accordion-item').toggleClass('show-body');
	});
});